// source: messages/members.message.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

goog.exportSymbol('proto.members_messages.AllGroupsListing', null, global);
goog.exportSymbol('proto.members_messages.GeneratePreferenceTokenRequest', null, global);
goog.exportSymbol('proto.members_messages.GeneratePreferenceTokenResponse', null, global);
goog.exportSymbol('proto.members_messages.GetAllGroupsListRequest', null, global);
goog.exportSymbol('proto.members_messages.GetAllGroupsListResponse', null, global);
goog.exportSymbol('proto.members_messages.GetAssignedPlanIdByMemberIdRequest', null, global);
goog.exportSymbol('proto.members_messages.GetAssignedPlanIdByMemberIdResponse', null, global);
goog.exportSymbol('proto.members_messages.GetCoreMemberAssignedPlansRequest', null, global);
goog.exportSymbol('proto.members_messages.GetCoreMemberAssignedPlansResponse', null, global);
goog.exportSymbol('proto.members_messages.GetCorePolicyIdByMemberIdRequest', null, global);
goog.exportSymbol('proto.members_messages.GetCorePolicyIdByMemberIdResponse', null, global);
goog.exportSymbol('proto.members_messages.GetGroupsListByPassGroupIdsRequest', null, global);
goog.exportSymbol('proto.members_messages.GetGroupsListByPassGroupIdsResponse', null, global);
goog.exportSymbol('proto.members_messages.GetPolicyIdByMemberIdRequest', null, global);
goog.exportSymbol('proto.members_messages.GetPolicyIdByMemberIdResponse', null, global);
goog.exportSymbol('proto.members_messages.GroupListing', null, global);
goog.exportSymbol('proto.members_messages.HasPolicyByMemberIdRequest', null, global);
goog.exportSymbol('proto.members_messages.HasPolicyByMemberIdResponse', null, global);
goog.exportSymbol('proto.members_messages.IsPremiumPaidRequest', null, global);
goog.exportSymbol('proto.members_messages.IsPremiumPaidResponse', null, global);
goog.exportSymbol('proto.members_messages.ListByPreferenceRequest', null, global);
goog.exportSymbol('proto.members_messages.ListByPreferenceResponse', null, global);
goog.exportSymbol('proto.members_messages.MemberAssignedPlans', null, global);
goog.exportSymbol('proto.members_messages.MemberLgPolicyId', null, global);
goog.exportSymbol('proto.members_messages.Preference', null, global);
goog.exportSymbol('proto.members_messages.PreferenceByTokenRequest', null, global);
goog.exportSymbol('proto.members_messages.PreferenceByTokenResponse', null, global);
goog.exportSymbol('proto.members_messages.PreferenceRequest', null, global);
goog.exportSymbol('proto.members_messages.PreferenceResponse', null, global);
goog.exportSymbol('proto.members_messages.PreferenceTypes', null, global);
goog.exportSymbol('proto.members_messages.RegeneratePreferenceTokenRequest', null, global);
goog.exportSymbol('proto.members_messages.RegeneratePreferenceTokenResponse', null, global);
goog.exportSymbol('proto.members_messages.Underwriter', null, global);
goog.exportSymbol('proto.members_messages.VerifyAssignedPlanIdByMemberIdRequest', null, global);
goog.exportSymbol('proto.members_messages.VerifyAssignedPlanIdByMemberIdResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.members_messages.ListByPreferenceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.members_messages.ListByPreferenceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.members_messages.ListByPreferenceRequest.displayName = 'proto.members_messages.ListByPreferenceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.members_messages.ListByPreferenceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.members_messages.ListByPreferenceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.members_messages.ListByPreferenceResponse.displayName = 'proto.members_messages.ListByPreferenceResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.members_messages.GeneratePreferenceTokenRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.members_messages.GeneratePreferenceTokenRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.members_messages.GeneratePreferenceTokenRequest.displayName = 'proto.members_messages.GeneratePreferenceTokenRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.members_messages.GeneratePreferenceTokenResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.members_messages.GeneratePreferenceTokenResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.members_messages.GeneratePreferenceTokenResponse.displayName = 'proto.members_messages.GeneratePreferenceTokenResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.members_messages.Preference = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.members_messages.Preference, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.members_messages.Preference.displayName = 'proto.members_messages.Preference';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.members_messages.MemberLgPolicyId = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.members_messages.MemberLgPolicyId, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.members_messages.MemberLgPolicyId.displayName = 'proto.members_messages.MemberLgPolicyId';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.members_messages.MemberAssignedPlans = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.members_messages.MemberAssignedPlans, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.members_messages.MemberAssignedPlans.displayName = 'proto.members_messages.MemberAssignedPlans';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.members_messages.PreferenceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.members_messages.PreferenceRequest.repeatedFields_, null);
};
goog.inherits(proto.members_messages.PreferenceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.members_messages.PreferenceRequest.displayName = 'proto.members_messages.PreferenceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.members_messages.PreferenceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.members_messages.PreferenceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.members_messages.PreferenceResponse.displayName = 'proto.members_messages.PreferenceResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.members_messages.PreferenceByTokenRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.members_messages.PreferenceByTokenRequest.repeatedFields_, null);
};
goog.inherits(proto.members_messages.PreferenceByTokenRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.members_messages.PreferenceByTokenRequest.displayName = 'proto.members_messages.PreferenceByTokenRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.members_messages.PreferenceByTokenResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.members_messages.PreferenceByTokenResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.members_messages.PreferenceByTokenResponse.displayName = 'proto.members_messages.PreferenceByTokenResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.members_messages.RegeneratePreferenceTokenRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.members_messages.RegeneratePreferenceTokenRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.members_messages.RegeneratePreferenceTokenRequest.displayName = 'proto.members_messages.RegeneratePreferenceTokenRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.members_messages.RegeneratePreferenceTokenResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.members_messages.RegeneratePreferenceTokenResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.members_messages.RegeneratePreferenceTokenResponse.displayName = 'proto.members_messages.RegeneratePreferenceTokenResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.members_messages.GetAssignedPlanIdByMemberIdRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.members_messages.GetAssignedPlanIdByMemberIdRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.members_messages.GetAssignedPlanIdByMemberIdRequest.displayName = 'proto.members_messages.GetAssignedPlanIdByMemberIdRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.members_messages.GetAssignedPlanIdByMemberIdResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.members_messages.GetAssignedPlanIdByMemberIdResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.members_messages.GetAssignedPlanIdByMemberIdResponse.displayName = 'proto.members_messages.GetAssignedPlanIdByMemberIdResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.members_messages.GroupListing = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.members_messages.GroupListing, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.members_messages.GroupListing.displayName = 'proto.members_messages.GroupListing';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.members_messages.GetGroupsListByPassGroupIdsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.members_messages.GetGroupsListByPassGroupIdsRequest.repeatedFields_, null);
};
goog.inherits(proto.members_messages.GetGroupsListByPassGroupIdsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.members_messages.GetGroupsListByPassGroupIdsRequest.displayName = 'proto.members_messages.GetGroupsListByPassGroupIdsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.members_messages.GetGroupsListByPassGroupIdsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.members_messages.GetGroupsListByPassGroupIdsResponse.repeatedFields_, null);
};
goog.inherits(proto.members_messages.GetGroupsListByPassGroupIdsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.members_messages.GetGroupsListByPassGroupIdsResponse.displayName = 'proto.members_messages.GetGroupsListByPassGroupIdsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.members_messages.AllGroupsListing = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.members_messages.AllGroupsListing, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.members_messages.AllGroupsListing.displayName = 'proto.members_messages.AllGroupsListing';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.members_messages.GetAllGroupsListRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.members_messages.GetAllGroupsListRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.members_messages.GetAllGroupsListRequest.displayName = 'proto.members_messages.GetAllGroupsListRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.members_messages.GetAllGroupsListResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.members_messages.GetAllGroupsListResponse.repeatedFields_, null);
};
goog.inherits(proto.members_messages.GetAllGroupsListResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.members_messages.GetAllGroupsListResponse.displayName = 'proto.members_messages.GetAllGroupsListResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.members_messages.VerifyAssignedPlanIdByMemberIdRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.members_messages.VerifyAssignedPlanIdByMemberIdRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.members_messages.VerifyAssignedPlanIdByMemberIdRequest.displayName = 'proto.members_messages.VerifyAssignedPlanIdByMemberIdRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.members_messages.VerifyAssignedPlanIdByMemberIdResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.members_messages.VerifyAssignedPlanIdByMemberIdResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.members_messages.VerifyAssignedPlanIdByMemberIdResponse.displayName = 'proto.members_messages.VerifyAssignedPlanIdByMemberIdResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.members_messages.GetPolicyIdByMemberIdRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.members_messages.GetPolicyIdByMemberIdRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.members_messages.GetPolicyIdByMemberIdRequest.displayName = 'proto.members_messages.GetPolicyIdByMemberIdRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.members_messages.GetPolicyIdByMemberIdResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.members_messages.GetPolicyIdByMemberIdResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.members_messages.GetPolicyIdByMemberIdResponse.displayName = 'proto.members_messages.GetPolicyIdByMemberIdResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.members_messages.HasPolicyByMemberIdRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.members_messages.HasPolicyByMemberIdRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.members_messages.HasPolicyByMemberIdRequest.displayName = 'proto.members_messages.HasPolicyByMemberIdRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.members_messages.HasPolicyByMemberIdResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.members_messages.HasPolicyByMemberIdResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.members_messages.HasPolicyByMemberIdResponse.displayName = 'proto.members_messages.HasPolicyByMemberIdResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.members_messages.GetCorePolicyIdByMemberIdRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.members_messages.GetCorePolicyIdByMemberIdRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.members_messages.GetCorePolicyIdByMemberIdRequest.displayName = 'proto.members_messages.GetCorePolicyIdByMemberIdRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.members_messages.GetCorePolicyIdByMemberIdResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.members_messages.GetCorePolicyIdByMemberIdResponse.repeatedFields_, null);
};
goog.inherits(proto.members_messages.GetCorePolicyIdByMemberIdResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.members_messages.GetCorePolicyIdByMemberIdResponse.displayName = 'proto.members_messages.GetCorePolicyIdByMemberIdResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.members_messages.GetCoreMemberAssignedPlansRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.members_messages.GetCoreMemberAssignedPlansRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.members_messages.GetCoreMemberAssignedPlansRequest.displayName = 'proto.members_messages.GetCoreMemberAssignedPlansRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.members_messages.GetCoreMemberAssignedPlansResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.members_messages.GetCoreMemberAssignedPlansResponse.repeatedFields_, null);
};
goog.inherits(proto.members_messages.GetCoreMemberAssignedPlansResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.members_messages.GetCoreMemberAssignedPlansResponse.displayName = 'proto.members_messages.GetCoreMemberAssignedPlansResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.members_messages.IsPremiumPaidRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.members_messages.IsPremiumPaidRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.members_messages.IsPremiumPaidRequest.displayName = 'proto.members_messages.IsPremiumPaidRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.members_messages.IsPremiumPaidResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.members_messages.IsPremiumPaidResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.members_messages.IsPremiumPaidResponse.displayName = 'proto.members_messages.IsPremiumPaidResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.members_messages.ListByPreferenceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.members_messages.ListByPreferenceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.members_messages.ListByPreferenceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.ListByPreferenceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
prefType: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.members_messages.ListByPreferenceRequest}
 */
proto.members_messages.ListByPreferenceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.members_messages.ListByPreferenceRequest;
  return proto.members_messages.ListByPreferenceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.members_messages.ListByPreferenceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.members_messages.ListByPreferenceRequest}
 */
proto.members_messages.ListByPreferenceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.members_messages.PreferenceTypes} */ (reader.readEnum());
      msg.setPrefType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.members_messages.ListByPreferenceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.members_messages.ListByPreferenceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.members_messages.ListByPreferenceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.ListByPreferenceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPrefType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional PreferenceTypes pref_type = 1;
 * @return {!proto.members_messages.PreferenceTypes}
 */
proto.members_messages.ListByPreferenceRequest.prototype.getPrefType = function() {
  return /** @type {!proto.members_messages.PreferenceTypes} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.members_messages.PreferenceTypes} value
 * @return {!proto.members_messages.ListByPreferenceRequest} returns this
 */
proto.members_messages.ListByPreferenceRequest.prototype.setPrefType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.members_messages.ListByPreferenceResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.members_messages.ListByPreferenceResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.members_messages.ListByPreferenceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.ListByPreferenceResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.members_messages.ListByPreferenceResponse}
 */
proto.members_messages.ListByPreferenceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.members_messages.ListByPreferenceResponse;
  return proto.members_messages.ListByPreferenceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.members_messages.ListByPreferenceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.members_messages.ListByPreferenceResponse}
 */
proto.members_messages.ListByPreferenceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.members_messages.ListByPreferenceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.members_messages.ListByPreferenceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.members_messages.ListByPreferenceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.ListByPreferenceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.members_messages.GeneratePreferenceTokenRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.members_messages.GeneratePreferenceTokenRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.members_messages.GeneratePreferenceTokenRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.GeneratePreferenceTokenRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
memberId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.members_messages.GeneratePreferenceTokenRequest}
 */
proto.members_messages.GeneratePreferenceTokenRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.members_messages.GeneratePreferenceTokenRequest;
  return proto.members_messages.GeneratePreferenceTokenRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.members_messages.GeneratePreferenceTokenRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.members_messages.GeneratePreferenceTokenRequest}
 */
proto.members_messages.GeneratePreferenceTokenRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMemberId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.members_messages.GeneratePreferenceTokenRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.members_messages.GeneratePreferenceTokenRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.members_messages.GeneratePreferenceTokenRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.GeneratePreferenceTokenRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMemberId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 member_id = 1;
 * @return {number}
 */
proto.members_messages.GeneratePreferenceTokenRequest.prototype.getMemberId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.members_messages.GeneratePreferenceTokenRequest} returns this
 */
proto.members_messages.GeneratePreferenceTokenRequest.prototype.setMemberId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.members_messages.GeneratePreferenceTokenResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.members_messages.GeneratePreferenceTokenResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.members_messages.GeneratePreferenceTokenResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.GeneratePreferenceTokenResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
token: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.members_messages.GeneratePreferenceTokenResponse}
 */
proto.members_messages.GeneratePreferenceTokenResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.members_messages.GeneratePreferenceTokenResponse;
  return proto.members_messages.GeneratePreferenceTokenResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.members_messages.GeneratePreferenceTokenResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.members_messages.GeneratePreferenceTokenResponse}
 */
proto.members_messages.GeneratePreferenceTokenResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.members_messages.GeneratePreferenceTokenResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.members_messages.GeneratePreferenceTokenResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.members_messages.GeneratePreferenceTokenResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.GeneratePreferenceTokenResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string token = 1;
 * @return {string}
 */
proto.members_messages.GeneratePreferenceTokenResponse.prototype.getToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.GeneratePreferenceTokenResponse} returns this
 */
proto.members_messages.GeneratePreferenceTokenResponse.prototype.setToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.members_messages.Preference.prototype.toObject = function(opt_includeInstance) {
  return proto.members_messages.Preference.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.members_messages.Preference} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.Preference.toObject = function(includeInstance, msg) {
  var f, obj = {
prefType: jspb.Message.getFieldWithDefault(msg, 1, 0),
value: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.members_messages.Preference}
 */
proto.members_messages.Preference.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.members_messages.Preference;
  return proto.members_messages.Preference.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.members_messages.Preference} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.members_messages.Preference}
 */
proto.members_messages.Preference.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.members_messages.PreferenceTypes} */ (reader.readEnum());
      msg.setPrefType(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.members_messages.Preference.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.members_messages.Preference.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.members_messages.Preference} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.Preference.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPrefType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getValue();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional PreferenceTypes pref_type = 1;
 * @return {!proto.members_messages.PreferenceTypes}
 */
proto.members_messages.Preference.prototype.getPrefType = function() {
  return /** @type {!proto.members_messages.PreferenceTypes} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.members_messages.PreferenceTypes} value
 * @return {!proto.members_messages.Preference} returns this
 */
proto.members_messages.Preference.prototype.setPrefType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional bool value = 2;
 * @return {boolean}
 */
proto.members_messages.Preference.prototype.getValue = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.members_messages.Preference} returns this
 */
proto.members_messages.Preference.prototype.setValue = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.members_messages.MemberLgPolicyId.prototype.toObject = function(opt_includeInstance) {
  return proto.members_messages.MemberLgPolicyId.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.members_messages.MemberLgPolicyId} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.MemberLgPolicyId.toObject = function(includeInstance, msg) {
  var f, obj = {
lgPolicyId: jspb.Message.getFieldWithDefault(msg, 1, 0),
assignedPlanId: jspb.Message.getFieldWithDefault(msg, 2, 0),
effectiveDate: jspb.Message.getFieldWithDefault(msg, 3, 0),
cancellationDate: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
underwriter: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.members_messages.MemberLgPolicyId}
 */
proto.members_messages.MemberLgPolicyId.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.members_messages.MemberLgPolicyId;
  return proto.members_messages.MemberLgPolicyId.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.members_messages.MemberLgPolicyId} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.members_messages.MemberLgPolicyId}
 */
proto.members_messages.MemberLgPolicyId.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLgPolicyId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAssignedPlanId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEffectiveDate(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCancellationDate(value);
      break;
    case 5:
      var value = /** @type {!proto.members_messages.Underwriter} */ (reader.readEnum());
      msg.setUnderwriter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.members_messages.MemberLgPolicyId.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.members_messages.MemberLgPolicyId.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.members_messages.MemberLgPolicyId} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.MemberLgPolicyId.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLgPolicyId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getAssignedPlanId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getEffectiveDate();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = /** @type {!proto.members_messages.Underwriter} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeEnum(
      5,
      f
    );
  }
};


/**
 * optional int32 lg_policy_id = 1;
 * @return {number}
 */
proto.members_messages.MemberLgPolicyId.prototype.getLgPolicyId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.members_messages.MemberLgPolicyId} returns this
 */
proto.members_messages.MemberLgPolicyId.prototype.setLgPolicyId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 assigned_plan_id = 2;
 * @return {number}
 */
proto.members_messages.MemberLgPolicyId.prototype.getAssignedPlanId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.members_messages.MemberLgPolicyId} returns this
 */
proto.members_messages.MemberLgPolicyId.prototype.setAssignedPlanId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 effective_date = 3;
 * @return {number}
 */
proto.members_messages.MemberLgPolicyId.prototype.getEffectiveDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.members_messages.MemberLgPolicyId} returns this
 */
proto.members_messages.MemberLgPolicyId.prototype.setEffectiveDate = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 cancellation_date = 4;
 * @return {number}
 */
proto.members_messages.MemberLgPolicyId.prototype.getCancellationDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.members_messages.MemberLgPolicyId} returns this
 */
proto.members_messages.MemberLgPolicyId.prototype.setCancellationDate = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.members_messages.MemberLgPolicyId} returns this
 */
proto.members_messages.MemberLgPolicyId.prototype.clearCancellationDate = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.members_messages.MemberLgPolicyId.prototype.hasCancellationDate = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Underwriter underwriter = 5;
 * @return {!proto.members_messages.Underwriter}
 */
proto.members_messages.MemberLgPolicyId.prototype.getUnderwriter = function() {
  return /** @type {!proto.members_messages.Underwriter} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.members_messages.Underwriter} value
 * @return {!proto.members_messages.MemberLgPolicyId} returns this
 */
proto.members_messages.MemberLgPolicyId.prototype.setUnderwriter = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.members_messages.MemberLgPolicyId} returns this
 */
proto.members_messages.MemberLgPolicyId.prototype.clearUnderwriter = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.members_messages.MemberLgPolicyId.prototype.hasUnderwriter = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.members_messages.MemberAssignedPlans.prototype.toObject = function(opt_includeInstance) {
  return proto.members_messages.MemberAssignedPlans.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.members_messages.MemberAssignedPlans} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.MemberAssignedPlans.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
memberId: jspb.Message.getFieldWithDefault(msg, 2, 0),
passGroupId: jspb.Message.getFieldWithDefault(msg, 3, ""),
assignedPlanId: jspb.Message.getFieldWithDefault(msg, 4, 0),
effectiveDate: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.members_messages.MemberAssignedPlans}
 */
proto.members_messages.MemberAssignedPlans.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.members_messages.MemberAssignedPlans;
  return proto.members_messages.MemberAssignedPlans.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.members_messages.MemberAssignedPlans} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.members_messages.MemberAssignedPlans}
 */
proto.members_messages.MemberAssignedPlans.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMemberId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassGroupId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAssignedPlanId(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEffectiveDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.members_messages.MemberAssignedPlans.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.members_messages.MemberAssignedPlans.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.members_messages.MemberAssignedPlans} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.MemberAssignedPlans.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getMemberId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPassGroupId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAssignedPlanId();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getEffectiveDate();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.members_messages.MemberAssignedPlans.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.members_messages.MemberAssignedPlans} returns this
 */
proto.members_messages.MemberAssignedPlans.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 member_id = 2;
 * @return {number}
 */
proto.members_messages.MemberAssignedPlans.prototype.getMemberId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.members_messages.MemberAssignedPlans} returns this
 */
proto.members_messages.MemberAssignedPlans.prototype.setMemberId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string pass_group_id = 3;
 * @return {string}
 */
proto.members_messages.MemberAssignedPlans.prototype.getPassGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.MemberAssignedPlans} returns this
 */
proto.members_messages.MemberAssignedPlans.prototype.setPassGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 assigned_plan_id = 4;
 * @return {number}
 */
proto.members_messages.MemberAssignedPlans.prototype.getAssignedPlanId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.members_messages.MemberAssignedPlans} returns this
 */
proto.members_messages.MemberAssignedPlans.prototype.setAssignedPlanId = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 effective_date = 5;
 * @return {number}
 */
proto.members_messages.MemberAssignedPlans.prototype.getEffectiveDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.members_messages.MemberAssignedPlans} returns this
 */
proto.members_messages.MemberAssignedPlans.prototype.setEffectiveDate = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.members_messages.PreferenceRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.members_messages.PreferenceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.members_messages.PreferenceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.members_messages.PreferenceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.PreferenceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
jwt: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
prefsList: jspb.Message.toObjectList(msg.getPrefsList(),
    proto.members_messages.Preference.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.members_messages.PreferenceRequest}
 */
proto.members_messages.PreferenceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.members_messages.PreferenceRequest;
  return proto.members_messages.PreferenceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.members_messages.PreferenceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.members_messages.PreferenceRequest}
 */
proto.members_messages.PreferenceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setJwt(value);
      break;
    case 2:
      var value = new proto.members_messages.Preference;
      reader.readMessage(value,proto.members_messages.Preference.deserializeBinaryFromReader);
      msg.addPrefs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.members_messages.PreferenceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.members_messages.PreferenceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.members_messages.PreferenceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.PreferenceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPrefsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.members_messages.Preference.serializeBinaryToWriter
    );
  }
};


/**
 * optional string jwt = 1;
 * @return {string}
 */
proto.members_messages.PreferenceRequest.prototype.getJwt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.PreferenceRequest} returns this
 */
proto.members_messages.PreferenceRequest.prototype.setJwt = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.members_messages.PreferenceRequest} returns this
 */
proto.members_messages.PreferenceRequest.prototype.clearJwt = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.members_messages.PreferenceRequest.prototype.hasJwt = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated Preference prefs = 2;
 * @return {!Array<!proto.members_messages.Preference>}
 */
proto.members_messages.PreferenceRequest.prototype.getPrefsList = function() {
  return /** @type{!Array<!proto.members_messages.Preference>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.members_messages.Preference, 2));
};


/**
 * @param {!Array<!proto.members_messages.Preference>} value
 * @return {!proto.members_messages.PreferenceRequest} returns this
*/
proto.members_messages.PreferenceRequest.prototype.setPrefsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.members_messages.Preference=} opt_value
 * @param {number=} opt_index
 * @return {!proto.members_messages.Preference}
 */
proto.members_messages.PreferenceRequest.prototype.addPrefs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.members_messages.Preference, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.members_messages.PreferenceRequest} returns this
 */
proto.members_messages.PreferenceRequest.prototype.clearPrefsList = function() {
  return this.setPrefsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.members_messages.PreferenceResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.members_messages.PreferenceResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.members_messages.PreferenceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.PreferenceResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.members_messages.PreferenceResponse}
 */
proto.members_messages.PreferenceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.members_messages.PreferenceResponse;
  return proto.members_messages.PreferenceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.members_messages.PreferenceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.members_messages.PreferenceResponse}
 */
proto.members_messages.PreferenceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.members_messages.PreferenceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.members_messages.PreferenceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.members_messages.PreferenceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.PreferenceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.members_messages.PreferenceByTokenRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.members_messages.PreferenceByTokenRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.members_messages.PreferenceByTokenRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.members_messages.PreferenceByTokenRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.PreferenceByTokenRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
token: jspb.Message.getFieldWithDefault(msg, 1, ""),
email: jspb.Message.getFieldWithDefault(msg, 2, ""),
prefsList: jspb.Message.toObjectList(msg.getPrefsList(),
    proto.members_messages.Preference.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.members_messages.PreferenceByTokenRequest}
 */
proto.members_messages.PreferenceByTokenRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.members_messages.PreferenceByTokenRequest;
  return proto.members_messages.PreferenceByTokenRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.members_messages.PreferenceByTokenRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.members_messages.PreferenceByTokenRequest}
 */
proto.members_messages.PreferenceByTokenRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setToken(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 3:
      var value = new proto.members_messages.Preference;
      reader.readMessage(value,proto.members_messages.Preference.deserializeBinaryFromReader);
      msg.addPrefs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.members_messages.PreferenceByTokenRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.members_messages.PreferenceByTokenRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.members_messages.PreferenceByTokenRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.PreferenceByTokenRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPrefsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.members_messages.Preference.serializeBinaryToWriter
    );
  }
};


/**
 * optional string token = 1;
 * @return {string}
 */
proto.members_messages.PreferenceByTokenRequest.prototype.getToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.PreferenceByTokenRequest} returns this
 */
proto.members_messages.PreferenceByTokenRequest.prototype.setToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string email = 2;
 * @return {string}
 */
proto.members_messages.PreferenceByTokenRequest.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.PreferenceByTokenRequest} returns this
 */
proto.members_messages.PreferenceByTokenRequest.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated Preference prefs = 3;
 * @return {!Array<!proto.members_messages.Preference>}
 */
proto.members_messages.PreferenceByTokenRequest.prototype.getPrefsList = function() {
  return /** @type{!Array<!proto.members_messages.Preference>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.members_messages.Preference, 3));
};


/**
 * @param {!Array<!proto.members_messages.Preference>} value
 * @return {!proto.members_messages.PreferenceByTokenRequest} returns this
*/
proto.members_messages.PreferenceByTokenRequest.prototype.setPrefsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.members_messages.Preference=} opt_value
 * @param {number=} opt_index
 * @return {!proto.members_messages.Preference}
 */
proto.members_messages.PreferenceByTokenRequest.prototype.addPrefs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.members_messages.Preference, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.members_messages.PreferenceByTokenRequest} returns this
 */
proto.members_messages.PreferenceByTokenRequest.prototype.clearPrefsList = function() {
  return this.setPrefsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.members_messages.PreferenceByTokenResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.members_messages.PreferenceByTokenResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.members_messages.PreferenceByTokenResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.PreferenceByTokenResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.members_messages.PreferenceByTokenResponse}
 */
proto.members_messages.PreferenceByTokenResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.members_messages.PreferenceByTokenResponse;
  return proto.members_messages.PreferenceByTokenResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.members_messages.PreferenceByTokenResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.members_messages.PreferenceByTokenResponse}
 */
proto.members_messages.PreferenceByTokenResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.members_messages.PreferenceByTokenResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.members_messages.PreferenceByTokenResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.members_messages.PreferenceByTokenResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.PreferenceByTokenResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.members_messages.RegeneratePreferenceTokenRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.members_messages.RegeneratePreferenceTokenRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.members_messages.RegeneratePreferenceTokenRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.RegeneratePreferenceTokenRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
token: jspb.Message.getFieldWithDefault(msg, 1, ""),
email: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.members_messages.RegeneratePreferenceTokenRequest}
 */
proto.members_messages.RegeneratePreferenceTokenRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.members_messages.RegeneratePreferenceTokenRequest;
  return proto.members_messages.RegeneratePreferenceTokenRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.members_messages.RegeneratePreferenceTokenRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.members_messages.RegeneratePreferenceTokenRequest}
 */
proto.members_messages.RegeneratePreferenceTokenRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setToken(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.members_messages.RegeneratePreferenceTokenRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.members_messages.RegeneratePreferenceTokenRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.members_messages.RegeneratePreferenceTokenRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.RegeneratePreferenceTokenRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string token = 1;
 * @return {string}
 */
proto.members_messages.RegeneratePreferenceTokenRequest.prototype.getToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.RegeneratePreferenceTokenRequest} returns this
 */
proto.members_messages.RegeneratePreferenceTokenRequest.prototype.setToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string email = 2;
 * @return {string}
 */
proto.members_messages.RegeneratePreferenceTokenRequest.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.RegeneratePreferenceTokenRequest} returns this
 */
proto.members_messages.RegeneratePreferenceTokenRequest.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.members_messages.RegeneratePreferenceTokenResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.members_messages.RegeneratePreferenceTokenResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.members_messages.RegeneratePreferenceTokenResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.RegeneratePreferenceTokenResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
token: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.members_messages.RegeneratePreferenceTokenResponse}
 */
proto.members_messages.RegeneratePreferenceTokenResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.members_messages.RegeneratePreferenceTokenResponse;
  return proto.members_messages.RegeneratePreferenceTokenResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.members_messages.RegeneratePreferenceTokenResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.members_messages.RegeneratePreferenceTokenResponse}
 */
proto.members_messages.RegeneratePreferenceTokenResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.members_messages.RegeneratePreferenceTokenResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.members_messages.RegeneratePreferenceTokenResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.members_messages.RegeneratePreferenceTokenResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.RegeneratePreferenceTokenResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string token = 1;
 * @return {string}
 */
proto.members_messages.RegeneratePreferenceTokenResponse.prototype.getToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.RegeneratePreferenceTokenResponse} returns this
 */
proto.members_messages.RegeneratePreferenceTokenResponse.prototype.setToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.members_messages.GetAssignedPlanIdByMemberIdRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.members_messages.GetAssignedPlanIdByMemberIdRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.members_messages.GetAssignedPlanIdByMemberIdRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.GetAssignedPlanIdByMemberIdRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
memberId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.members_messages.GetAssignedPlanIdByMemberIdRequest}
 */
proto.members_messages.GetAssignedPlanIdByMemberIdRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.members_messages.GetAssignedPlanIdByMemberIdRequest;
  return proto.members_messages.GetAssignedPlanIdByMemberIdRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.members_messages.GetAssignedPlanIdByMemberIdRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.members_messages.GetAssignedPlanIdByMemberIdRequest}
 */
proto.members_messages.GetAssignedPlanIdByMemberIdRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMemberId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.members_messages.GetAssignedPlanIdByMemberIdRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.members_messages.GetAssignedPlanIdByMemberIdRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.members_messages.GetAssignedPlanIdByMemberIdRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.GetAssignedPlanIdByMemberIdRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMemberId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 member_id = 1;
 * @return {number}
 */
proto.members_messages.GetAssignedPlanIdByMemberIdRequest.prototype.getMemberId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.members_messages.GetAssignedPlanIdByMemberIdRequest} returns this
 */
proto.members_messages.GetAssignedPlanIdByMemberIdRequest.prototype.setMemberId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.members_messages.GetAssignedPlanIdByMemberIdResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.members_messages.GetAssignedPlanIdByMemberIdResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.members_messages.GetAssignedPlanIdByMemberIdResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.GetAssignedPlanIdByMemberIdResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
assignedPlanId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.members_messages.GetAssignedPlanIdByMemberIdResponse}
 */
proto.members_messages.GetAssignedPlanIdByMemberIdResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.members_messages.GetAssignedPlanIdByMemberIdResponse;
  return proto.members_messages.GetAssignedPlanIdByMemberIdResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.members_messages.GetAssignedPlanIdByMemberIdResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.members_messages.GetAssignedPlanIdByMemberIdResponse}
 */
proto.members_messages.GetAssignedPlanIdByMemberIdResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssignedPlanId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.members_messages.GetAssignedPlanIdByMemberIdResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.members_messages.GetAssignedPlanIdByMemberIdResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.members_messages.GetAssignedPlanIdByMemberIdResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.GetAssignedPlanIdByMemberIdResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAssignedPlanId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string assigned_plan_id = 1;
 * @return {string}
 */
proto.members_messages.GetAssignedPlanIdByMemberIdResponse.prototype.getAssignedPlanId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.GetAssignedPlanIdByMemberIdResponse} returns this
 */
proto.members_messages.GetAssignedPlanIdByMemberIdResponse.prototype.setAssignedPlanId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.members_messages.GroupListing.prototype.toObject = function(opt_includeInstance) {
  return proto.members_messages.GroupListing.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.members_messages.GroupListing} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.GroupListing.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
groupId: jspb.Message.getFieldWithDefault(msg, 2, 0),
parentGroupId: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
subGroupId: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
passId: jspb.Message.getFieldWithDefault(msg, 5, ""),
passGroupId: jspb.Message.getFieldWithDefault(msg, 6, ""),
name: jspb.Message.getFieldWithDefault(msg, 7, ""),
address1: jspb.Message.getFieldWithDefault(msg, 8, ""),
address2: jspb.Message.getFieldWithDefault(msg, 9, ""),
city: jspb.Message.getFieldWithDefault(msg, 10, ""),
state: jspb.Message.getFieldWithDefault(msg, 11, ""),
zipCode: jspb.Message.getFieldWithDefault(msg, 12, ""),
country: jspb.Message.getFieldWithDefault(msg, 13, ""),
billingCompanyName: (f = jspb.Message.getField(msg, 14)) == null ? undefined : f,
billingAttentionTo: (f = jspb.Message.getField(msg, 15)) == null ? undefined : f,
billingPurchaseOrderNumber: (f = jspb.Message.getField(msg, 16)) == null ? undefined : f,
previousPurchaseOrderNumber: jspb.Message.getFieldWithDefault(msg, 17, ""),
billingInvoiceEmailAddress: (f = jspb.Message.getField(msg, 18)) == null ? undefined : f,
billingAddress1: jspb.Message.getFieldWithDefault(msg, 19, ""),
billingAddress2: jspb.Message.getFieldWithDefault(msg, 20, ""),
billingCity: jspb.Message.getFieldWithDefault(msg, 21, ""),
billingState: jspb.Message.getFieldWithDefault(msg, 22, ""),
billingZipCode: jspb.Message.getFieldWithDefault(msg, 23, ""),
groupEffectiveDate: jspb.Message.getFieldWithDefault(msg, 24, ""),
sicCode: jspb.Message.getFieldWithDefault(msg, 25, ""),
mga: jspb.Message.getFieldWithDefault(msg, 26, ""),
tpaEligibility: (f = jspb.Message.getField(msg, 27)) == null ? undefined : f,
tpaEnrollment: (f = jspb.Message.getField(msg, 28)) == null ? undefined : f,
tpaReconciliation: (f = jspb.Message.getField(msg, 29)) == null ? undefined : f,
memberPrimaryKey: (f = jspb.Message.getField(msg, 30)) == null ? undefined : f,
memberEnrollmentRule: jspb.Message.getFieldWithDefault(msg, 31, ""),
memberCancellationRule: jspb.Message.getFieldWithDefault(msg, 32, ""),
enrollmentCutoffDayOfMonth: jspb.Message.getFieldWithDefault(msg, 33, 0),
enrollmentType: (f = jspb.Message.getField(msg, 34)) == null ? undefined : f,
enrollmentTypeAlternate: (f = jspb.Message.getField(msg, 35)) == null ? undefined : f,
enrollmentDescription: (f = jspb.Message.getField(msg, 36)) == null ? undefined : f,
invoiceType: jspb.Message.getFieldWithDefault(msg, 37, ""),
splitInvoice: jspb.Message.getFieldWithDefault(msg, 38, ""),
displayOnInvoice: (f = jspb.Message.getField(msg, 39)) == null ? undefined : f,
dayOfMonthInvoiceDue: jspb.Message.getFieldWithDefault(msg, 40, 0),
reconciliationType: jspb.Message.getFieldWithDefault(msg, 41, ""),
reconciliationInstructions: (f = jspb.Message.getField(msg, 42)) == null ? undefined : f,
reconciliationMethod: jspb.Message.getFieldWithDefault(msg, 43, ""),
paymentType: jspb.Message.getFieldWithDefault(msg, 44, ""),
depositAccount: jspb.Message.getFieldWithDefault(msg, 45, ""),
websiteAddress: (f = jspb.Message.getField(msg, 46)) == null ? undefined : f,
createdBy: jspb.Message.getFieldWithDefault(msg, 47, ""),
createdDate: jspb.Message.getFieldWithDefault(msg, 48, ""),
groupStatus: jspb.Message.getFieldWithDefault(msg, 49, ""),
groupCancellationDate: (f = jspb.Message.getField(msg, 50)) == null ? undefined : f,
groupCancelledBy: jspb.Message.getFieldWithDefault(msg, 51, ""),
cancelledDate: (f = jspb.Message.getField(msg, 52)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.members_messages.GroupListing}
 */
proto.members_messages.GroupListing.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.members_messages.GroupListing;
  return proto.members_messages.GroupListing.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.members_messages.GroupListing} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.members_messages.GroupListing}
 */
proto.members_messages.GroupListing.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setGroupId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setParentGroupId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSubGroupId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassGroupId(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress1(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress2(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setCity(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setState(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setZipCode(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setBillingCompanyName(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setBillingAttentionTo(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setBillingPurchaseOrderNumber(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setPreviousPurchaseOrderNumber(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setBillingInvoiceEmailAddress(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setBillingAddress1(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setBillingAddress2(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setBillingCity(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setBillingState(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.setBillingZipCode(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupEffectiveDate(value);
      break;
    case 25:
      var value = /** @type {string} */ (reader.readString());
      msg.setSicCode(value);
      break;
    case 26:
      var value = /** @type {string} */ (reader.readString());
      msg.setMga(value);
      break;
    case 27:
      var value = /** @type {string} */ (reader.readString());
      msg.setTpaEligibility(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setTpaEnrollment(value);
      break;
    case 29:
      var value = /** @type {string} */ (reader.readString());
      msg.setTpaReconciliation(value);
      break;
    case 30:
      var value = /** @type {string} */ (reader.readString());
      msg.setMemberPrimaryKey(value);
      break;
    case 31:
      var value = /** @type {string} */ (reader.readString());
      msg.setMemberEnrollmentRule(value);
      break;
    case 32:
      var value = /** @type {string} */ (reader.readString());
      msg.setMemberCancellationRule(value);
      break;
    case 33:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setEnrollmentCutoffDayOfMonth(value);
      break;
    case 34:
      var value = /** @type {string} */ (reader.readString());
      msg.setEnrollmentType(value);
      break;
    case 35:
      var value = /** @type {string} */ (reader.readString());
      msg.setEnrollmentTypeAlternate(value);
      break;
    case 36:
      var value = /** @type {string} */ (reader.readString());
      msg.setEnrollmentDescription(value);
      break;
    case 37:
      var value = /** @type {string} */ (reader.readString());
      msg.setInvoiceType(value);
      break;
    case 38:
      var value = /** @type {string} */ (reader.readString());
      msg.setSplitInvoice(value);
      break;
    case 39:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayOnInvoice(value);
      break;
    case 40:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDayOfMonthInvoiceDue(value);
      break;
    case 41:
      var value = /** @type {string} */ (reader.readString());
      msg.setReconciliationType(value);
      break;
    case 42:
      var value = /** @type {string} */ (reader.readString());
      msg.setReconciliationInstructions(value);
      break;
    case 43:
      var value = /** @type {string} */ (reader.readString());
      msg.setReconciliationMethod(value);
      break;
    case 44:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaymentType(value);
      break;
    case 45:
      var value = /** @type {string} */ (reader.readString());
      msg.setDepositAccount(value);
      break;
    case 46:
      var value = /** @type {string} */ (reader.readString());
      msg.setWebsiteAddress(value);
      break;
    case 47:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedBy(value);
      break;
    case 48:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedDate(value);
      break;
    case 49:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupStatus(value);
      break;
    case 50:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupCancellationDate(value);
      break;
    case 51:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupCancelledBy(value);
      break;
    case 52:
      var value = /** @type {string} */ (reader.readString());
      msg.setCancelledDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.members_messages.GroupListing.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.members_messages.GroupListing.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.members_messages.GroupListing} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.GroupListing.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getGroupId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getPassId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPassGroupId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getAddress1();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getAddress2();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getState();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getZipCode();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 14));
  if (f != null) {
    writer.writeString(
      14,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 15));
  if (f != null) {
    writer.writeString(
      15,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 16));
  if (f != null) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getPreviousPurchaseOrderNumber();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 18));
  if (f != null) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getBillingAddress1();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getBillingAddress2();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getBillingCity();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getBillingState();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getBillingZipCode();
  if (f.length > 0) {
    writer.writeString(
      23,
      f
    );
  }
  f = message.getGroupEffectiveDate();
  if (f.length > 0) {
    writer.writeString(
      24,
      f
    );
  }
  f = message.getSicCode();
  if (f.length > 0) {
    writer.writeString(
      25,
      f
    );
  }
  f = message.getMga();
  if (f.length > 0) {
    writer.writeString(
      26,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 27));
  if (f != null) {
    writer.writeString(
      27,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 28));
  if (f != null) {
    writer.writeString(
      28,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 29));
  if (f != null) {
    writer.writeString(
      29,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 30));
  if (f != null) {
    writer.writeString(
      30,
      f
    );
  }
  f = message.getMemberEnrollmentRule();
  if (f.length > 0) {
    writer.writeString(
      31,
      f
    );
  }
  f = message.getMemberCancellationRule();
  if (f.length > 0) {
    writer.writeString(
      32,
      f
    );
  }
  f = message.getEnrollmentCutoffDayOfMonth();
  if (f !== 0) {
    writer.writeInt32(
      33,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 34));
  if (f != null) {
    writer.writeString(
      34,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 35));
  if (f != null) {
    writer.writeString(
      35,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 36));
  if (f != null) {
    writer.writeString(
      36,
      f
    );
  }
  f = message.getInvoiceType();
  if (f.length > 0) {
    writer.writeString(
      37,
      f
    );
  }
  f = message.getSplitInvoice();
  if (f.length > 0) {
    writer.writeString(
      38,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 39));
  if (f != null) {
    writer.writeString(
      39,
      f
    );
  }
  f = message.getDayOfMonthInvoiceDue();
  if (f !== 0) {
    writer.writeInt32(
      40,
      f
    );
  }
  f = message.getReconciliationType();
  if (f.length > 0) {
    writer.writeString(
      41,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 42));
  if (f != null) {
    writer.writeString(
      42,
      f
    );
  }
  f = message.getReconciliationMethod();
  if (f.length > 0) {
    writer.writeString(
      43,
      f
    );
  }
  f = message.getPaymentType();
  if (f.length > 0) {
    writer.writeString(
      44,
      f
    );
  }
  f = message.getDepositAccount();
  if (f.length > 0) {
    writer.writeString(
      45,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 46));
  if (f != null) {
    writer.writeString(
      46,
      f
    );
  }
  f = message.getCreatedBy();
  if (f.length > 0) {
    writer.writeString(
      47,
      f
    );
  }
  f = message.getCreatedDate();
  if (f.length > 0) {
    writer.writeString(
      48,
      f
    );
  }
  f = message.getGroupStatus();
  if (f.length > 0) {
    writer.writeString(
      49,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 50));
  if (f != null) {
    writer.writeString(
      50,
      f
    );
  }
  f = message.getGroupCancelledBy();
  if (f.length > 0) {
    writer.writeString(
      51,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 52));
  if (f != null) {
    writer.writeString(
      52,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.members_messages.GroupListing.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 group_id = 2;
 * @return {number}
 */
proto.members_messages.GroupListing.prototype.getGroupId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.setGroupId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 parent_group_id = 3;
 * @return {number}
 */
proto.members_messages.GroupListing.prototype.getParentGroupId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.setParentGroupId = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.clearParentGroupId = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.members_messages.GroupListing.prototype.hasParentGroupId = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int32 sub_group_id = 4;
 * @return {number}
 */
proto.members_messages.GroupListing.prototype.getSubGroupId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.setSubGroupId = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.clearSubGroupId = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.members_messages.GroupListing.prototype.hasSubGroupId = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string pass_id = 5;
 * @return {string}
 */
proto.members_messages.GroupListing.prototype.getPassId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.setPassId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string pass_group_id = 6;
 * @return {string}
 */
proto.members_messages.GroupListing.prototype.getPassGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.setPassGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string name = 7;
 * @return {string}
 */
proto.members_messages.GroupListing.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string address_1 = 8;
 * @return {string}
 */
proto.members_messages.GroupListing.prototype.getAddress1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.setAddress1 = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string address_2 = 9;
 * @return {string}
 */
proto.members_messages.GroupListing.prototype.getAddress2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.setAddress2 = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string city = 10;
 * @return {string}
 */
proto.members_messages.GroupListing.prototype.getCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.setCity = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string state = 11;
 * @return {string}
 */
proto.members_messages.GroupListing.prototype.getState = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.setState = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string zip_code = 12;
 * @return {string}
 */
proto.members_messages.GroupListing.prototype.getZipCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.setZipCode = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string country = 13;
 * @return {string}
 */
proto.members_messages.GroupListing.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.setCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string billing_company_name = 14;
 * @return {string}
 */
proto.members_messages.GroupListing.prototype.getBillingCompanyName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.setBillingCompanyName = function(value) {
  return jspb.Message.setField(this, 14, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.clearBillingCompanyName = function() {
  return jspb.Message.setField(this, 14, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.members_messages.GroupListing.prototype.hasBillingCompanyName = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional string billing_attention_to = 15;
 * @return {string}
 */
proto.members_messages.GroupListing.prototype.getBillingAttentionTo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.setBillingAttentionTo = function(value) {
  return jspb.Message.setField(this, 15, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.clearBillingAttentionTo = function() {
  return jspb.Message.setField(this, 15, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.members_messages.GroupListing.prototype.hasBillingAttentionTo = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional string billing_purchase_order_number = 16;
 * @return {string}
 */
proto.members_messages.GroupListing.prototype.getBillingPurchaseOrderNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.setBillingPurchaseOrderNumber = function(value) {
  return jspb.Message.setField(this, 16, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.clearBillingPurchaseOrderNumber = function() {
  return jspb.Message.setField(this, 16, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.members_messages.GroupListing.prototype.hasBillingPurchaseOrderNumber = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional string previous_purchase_order_number = 17;
 * @return {string}
 */
proto.members_messages.GroupListing.prototype.getPreviousPurchaseOrderNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.setPreviousPurchaseOrderNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string billing_invoice_email_address = 18;
 * @return {string}
 */
proto.members_messages.GroupListing.prototype.getBillingInvoiceEmailAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.setBillingInvoiceEmailAddress = function(value) {
  return jspb.Message.setField(this, 18, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.clearBillingInvoiceEmailAddress = function() {
  return jspb.Message.setField(this, 18, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.members_messages.GroupListing.prototype.hasBillingInvoiceEmailAddress = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional string billing_address_1 = 19;
 * @return {string}
 */
proto.members_messages.GroupListing.prototype.getBillingAddress1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.setBillingAddress1 = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string billing_address_2 = 20;
 * @return {string}
 */
proto.members_messages.GroupListing.prototype.getBillingAddress2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.setBillingAddress2 = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional string billing_city = 21;
 * @return {string}
 */
proto.members_messages.GroupListing.prototype.getBillingCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.setBillingCity = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional string billing_state = 22;
 * @return {string}
 */
proto.members_messages.GroupListing.prototype.getBillingState = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.setBillingState = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};


/**
 * optional string billing_zip_code = 23;
 * @return {string}
 */
proto.members_messages.GroupListing.prototype.getBillingZipCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.setBillingZipCode = function(value) {
  return jspb.Message.setProto3StringField(this, 23, value);
};


/**
 * optional string group_effective_date = 24;
 * @return {string}
 */
proto.members_messages.GroupListing.prototype.getGroupEffectiveDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.setGroupEffectiveDate = function(value) {
  return jspb.Message.setProto3StringField(this, 24, value);
};


/**
 * optional string sic_code = 25;
 * @return {string}
 */
proto.members_messages.GroupListing.prototype.getSicCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.setSicCode = function(value) {
  return jspb.Message.setProto3StringField(this, 25, value);
};


/**
 * optional string mga = 26;
 * @return {string}
 */
proto.members_messages.GroupListing.prototype.getMga = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.setMga = function(value) {
  return jspb.Message.setProto3StringField(this, 26, value);
};


/**
 * optional string tpa_eligibility = 27;
 * @return {string}
 */
proto.members_messages.GroupListing.prototype.getTpaEligibility = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.setTpaEligibility = function(value) {
  return jspb.Message.setField(this, 27, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.clearTpaEligibility = function() {
  return jspb.Message.setField(this, 27, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.members_messages.GroupListing.prototype.hasTpaEligibility = function() {
  return jspb.Message.getField(this, 27) != null;
};


/**
 * optional string tpa_enrollment = 28;
 * @return {string}
 */
proto.members_messages.GroupListing.prototype.getTpaEnrollment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.setTpaEnrollment = function(value) {
  return jspb.Message.setField(this, 28, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.clearTpaEnrollment = function() {
  return jspb.Message.setField(this, 28, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.members_messages.GroupListing.prototype.hasTpaEnrollment = function() {
  return jspb.Message.getField(this, 28) != null;
};


/**
 * optional string tpa_reconciliation = 29;
 * @return {string}
 */
proto.members_messages.GroupListing.prototype.getTpaReconciliation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 29, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.setTpaReconciliation = function(value) {
  return jspb.Message.setField(this, 29, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.clearTpaReconciliation = function() {
  return jspb.Message.setField(this, 29, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.members_messages.GroupListing.prototype.hasTpaReconciliation = function() {
  return jspb.Message.getField(this, 29) != null;
};


/**
 * optional string member_primary_key = 30;
 * @return {string}
 */
proto.members_messages.GroupListing.prototype.getMemberPrimaryKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 30, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.setMemberPrimaryKey = function(value) {
  return jspb.Message.setField(this, 30, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.clearMemberPrimaryKey = function() {
  return jspb.Message.setField(this, 30, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.members_messages.GroupListing.prototype.hasMemberPrimaryKey = function() {
  return jspb.Message.getField(this, 30) != null;
};


/**
 * optional string member_enrollment_rule = 31;
 * @return {string}
 */
proto.members_messages.GroupListing.prototype.getMemberEnrollmentRule = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 31, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.setMemberEnrollmentRule = function(value) {
  return jspb.Message.setProto3StringField(this, 31, value);
};


/**
 * optional string member_cancellation_rule = 32;
 * @return {string}
 */
proto.members_messages.GroupListing.prototype.getMemberCancellationRule = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 32, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.setMemberCancellationRule = function(value) {
  return jspb.Message.setProto3StringField(this, 32, value);
};


/**
 * optional int32 enrollment_cutoff_day_of_month = 33;
 * @return {number}
 */
proto.members_messages.GroupListing.prototype.getEnrollmentCutoffDayOfMonth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 33, 0));
};


/**
 * @param {number} value
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.setEnrollmentCutoffDayOfMonth = function(value) {
  return jspb.Message.setProto3IntField(this, 33, value);
};


/**
 * optional string enrollment_type = 34;
 * @return {string}
 */
proto.members_messages.GroupListing.prototype.getEnrollmentType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 34, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.setEnrollmentType = function(value) {
  return jspb.Message.setField(this, 34, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.clearEnrollmentType = function() {
  return jspb.Message.setField(this, 34, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.members_messages.GroupListing.prototype.hasEnrollmentType = function() {
  return jspb.Message.getField(this, 34) != null;
};


/**
 * optional string enrollment_type_alternate = 35;
 * @return {string}
 */
proto.members_messages.GroupListing.prototype.getEnrollmentTypeAlternate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 35, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.setEnrollmentTypeAlternate = function(value) {
  return jspb.Message.setField(this, 35, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.clearEnrollmentTypeAlternate = function() {
  return jspb.Message.setField(this, 35, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.members_messages.GroupListing.prototype.hasEnrollmentTypeAlternate = function() {
  return jspb.Message.getField(this, 35) != null;
};


/**
 * optional string enrollment_description = 36;
 * @return {string}
 */
proto.members_messages.GroupListing.prototype.getEnrollmentDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 36, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.setEnrollmentDescription = function(value) {
  return jspb.Message.setField(this, 36, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.clearEnrollmentDescription = function() {
  return jspb.Message.setField(this, 36, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.members_messages.GroupListing.prototype.hasEnrollmentDescription = function() {
  return jspb.Message.getField(this, 36) != null;
};


/**
 * optional string invoice_type = 37;
 * @return {string}
 */
proto.members_messages.GroupListing.prototype.getInvoiceType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 37, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.setInvoiceType = function(value) {
  return jspb.Message.setProto3StringField(this, 37, value);
};


/**
 * optional string split_invoice = 38;
 * @return {string}
 */
proto.members_messages.GroupListing.prototype.getSplitInvoice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 38, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.setSplitInvoice = function(value) {
  return jspb.Message.setProto3StringField(this, 38, value);
};


/**
 * optional string display_on_invoice = 39;
 * @return {string}
 */
proto.members_messages.GroupListing.prototype.getDisplayOnInvoice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 39, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.setDisplayOnInvoice = function(value) {
  return jspb.Message.setField(this, 39, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.clearDisplayOnInvoice = function() {
  return jspb.Message.setField(this, 39, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.members_messages.GroupListing.prototype.hasDisplayOnInvoice = function() {
  return jspb.Message.getField(this, 39) != null;
};


/**
 * optional int32 day_of_month_invoice_due = 40;
 * @return {number}
 */
proto.members_messages.GroupListing.prototype.getDayOfMonthInvoiceDue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 40, 0));
};


/**
 * @param {number} value
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.setDayOfMonthInvoiceDue = function(value) {
  return jspb.Message.setProto3IntField(this, 40, value);
};


/**
 * optional string reconciliation_type = 41;
 * @return {string}
 */
proto.members_messages.GroupListing.prototype.getReconciliationType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 41, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.setReconciliationType = function(value) {
  return jspb.Message.setProto3StringField(this, 41, value);
};


/**
 * optional string reconciliation_instructions = 42;
 * @return {string}
 */
proto.members_messages.GroupListing.prototype.getReconciliationInstructions = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 42, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.setReconciliationInstructions = function(value) {
  return jspb.Message.setField(this, 42, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.clearReconciliationInstructions = function() {
  return jspb.Message.setField(this, 42, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.members_messages.GroupListing.prototype.hasReconciliationInstructions = function() {
  return jspb.Message.getField(this, 42) != null;
};


/**
 * optional string reconciliation_method = 43;
 * @return {string}
 */
proto.members_messages.GroupListing.prototype.getReconciliationMethod = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 43, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.setReconciliationMethod = function(value) {
  return jspb.Message.setProto3StringField(this, 43, value);
};


/**
 * optional string payment_type = 44;
 * @return {string}
 */
proto.members_messages.GroupListing.prototype.getPaymentType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 44, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.setPaymentType = function(value) {
  return jspb.Message.setProto3StringField(this, 44, value);
};


/**
 * optional string deposit_account = 45;
 * @return {string}
 */
proto.members_messages.GroupListing.prototype.getDepositAccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 45, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.setDepositAccount = function(value) {
  return jspb.Message.setProto3StringField(this, 45, value);
};


/**
 * optional string website_address = 46;
 * @return {string}
 */
proto.members_messages.GroupListing.prototype.getWebsiteAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 46, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.setWebsiteAddress = function(value) {
  return jspb.Message.setField(this, 46, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.clearWebsiteAddress = function() {
  return jspb.Message.setField(this, 46, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.members_messages.GroupListing.prototype.hasWebsiteAddress = function() {
  return jspb.Message.getField(this, 46) != null;
};


/**
 * optional string created_by = 47;
 * @return {string}
 */
proto.members_messages.GroupListing.prototype.getCreatedBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 47, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.setCreatedBy = function(value) {
  return jspb.Message.setProto3StringField(this, 47, value);
};


/**
 * optional string created_date = 48;
 * @return {string}
 */
proto.members_messages.GroupListing.prototype.getCreatedDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 48, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.setCreatedDate = function(value) {
  return jspb.Message.setProto3StringField(this, 48, value);
};


/**
 * optional string group_status = 49;
 * @return {string}
 */
proto.members_messages.GroupListing.prototype.getGroupStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 49, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.setGroupStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 49, value);
};


/**
 * optional string group_cancellation_date = 50;
 * @return {string}
 */
proto.members_messages.GroupListing.prototype.getGroupCancellationDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 50, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.setGroupCancellationDate = function(value) {
  return jspb.Message.setField(this, 50, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.clearGroupCancellationDate = function() {
  return jspb.Message.setField(this, 50, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.members_messages.GroupListing.prototype.hasGroupCancellationDate = function() {
  return jspb.Message.getField(this, 50) != null;
};


/**
 * optional string group_cancelled_by = 51;
 * @return {string}
 */
proto.members_messages.GroupListing.prototype.getGroupCancelledBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 51, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.setGroupCancelledBy = function(value) {
  return jspb.Message.setProto3StringField(this, 51, value);
};


/**
 * optional string cancelled_date = 52;
 * @return {string}
 */
proto.members_messages.GroupListing.prototype.getCancelledDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 52, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.setCancelledDate = function(value) {
  return jspb.Message.setField(this, 52, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.members_messages.GroupListing} returns this
 */
proto.members_messages.GroupListing.prototype.clearCancelledDate = function() {
  return jspb.Message.setField(this, 52, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.members_messages.GroupListing.prototype.hasCancelledDate = function() {
  return jspb.Message.getField(this, 52) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.members_messages.GetGroupsListByPassGroupIdsRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.members_messages.GetGroupsListByPassGroupIdsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.members_messages.GetGroupsListByPassGroupIdsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.members_messages.GetGroupsListByPassGroupIdsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.GetGroupsListByPassGroupIdsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
passGroupIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.members_messages.GetGroupsListByPassGroupIdsRequest}
 */
proto.members_messages.GetGroupsListByPassGroupIdsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.members_messages.GetGroupsListByPassGroupIdsRequest;
  return proto.members_messages.GetGroupsListByPassGroupIdsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.members_messages.GetGroupsListByPassGroupIdsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.members_messages.GetGroupsListByPassGroupIdsRequest}
 */
proto.members_messages.GetGroupsListByPassGroupIdsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addPassGroupIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.members_messages.GetGroupsListByPassGroupIdsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.members_messages.GetGroupsListByPassGroupIdsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.members_messages.GetGroupsListByPassGroupIdsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.GetGroupsListByPassGroupIdsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPassGroupIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string pass_group_ids = 1;
 * @return {!Array<string>}
 */
proto.members_messages.GetGroupsListByPassGroupIdsRequest.prototype.getPassGroupIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.members_messages.GetGroupsListByPassGroupIdsRequest} returns this
 */
proto.members_messages.GetGroupsListByPassGroupIdsRequest.prototype.setPassGroupIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.members_messages.GetGroupsListByPassGroupIdsRequest} returns this
 */
proto.members_messages.GetGroupsListByPassGroupIdsRequest.prototype.addPassGroupIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.members_messages.GetGroupsListByPassGroupIdsRequest} returns this
 */
proto.members_messages.GetGroupsListByPassGroupIdsRequest.prototype.clearPassGroupIdsList = function() {
  return this.setPassGroupIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.members_messages.GetGroupsListByPassGroupIdsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.members_messages.GetGroupsListByPassGroupIdsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.members_messages.GetGroupsListByPassGroupIdsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.members_messages.GetGroupsListByPassGroupIdsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.GetGroupsListByPassGroupIdsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
groupListingsList: jspb.Message.toObjectList(msg.getGroupListingsList(),
    proto.members_messages.GroupListing.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.members_messages.GetGroupsListByPassGroupIdsResponse}
 */
proto.members_messages.GetGroupsListByPassGroupIdsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.members_messages.GetGroupsListByPassGroupIdsResponse;
  return proto.members_messages.GetGroupsListByPassGroupIdsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.members_messages.GetGroupsListByPassGroupIdsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.members_messages.GetGroupsListByPassGroupIdsResponse}
 */
proto.members_messages.GetGroupsListByPassGroupIdsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.members_messages.GroupListing;
      reader.readMessage(value,proto.members_messages.GroupListing.deserializeBinaryFromReader);
      msg.addGroupListings(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.members_messages.GetGroupsListByPassGroupIdsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.members_messages.GetGroupsListByPassGroupIdsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.members_messages.GetGroupsListByPassGroupIdsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.GetGroupsListByPassGroupIdsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroupListingsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.members_messages.GroupListing.serializeBinaryToWriter
    );
  }
};


/**
 * repeated GroupListing group_listings = 1;
 * @return {!Array<!proto.members_messages.GroupListing>}
 */
proto.members_messages.GetGroupsListByPassGroupIdsResponse.prototype.getGroupListingsList = function() {
  return /** @type{!Array<!proto.members_messages.GroupListing>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.members_messages.GroupListing, 1));
};


/**
 * @param {!Array<!proto.members_messages.GroupListing>} value
 * @return {!proto.members_messages.GetGroupsListByPassGroupIdsResponse} returns this
*/
proto.members_messages.GetGroupsListByPassGroupIdsResponse.prototype.setGroupListingsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.members_messages.GroupListing=} opt_value
 * @param {number=} opt_index
 * @return {!proto.members_messages.GroupListing}
 */
proto.members_messages.GetGroupsListByPassGroupIdsResponse.prototype.addGroupListings = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.members_messages.GroupListing, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.members_messages.GetGroupsListByPassGroupIdsResponse} returns this
 */
proto.members_messages.GetGroupsListByPassGroupIdsResponse.prototype.clearGroupListingsList = function() {
  return this.setGroupListingsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.members_messages.AllGroupsListing.prototype.toObject = function(opt_includeInstance) {
  return proto.members_messages.AllGroupsListing.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.members_messages.AllGroupsListing} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.AllGroupsListing.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
passGroupId: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
verified: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.members_messages.AllGroupsListing}
 */
proto.members_messages.AllGroupsListing.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.members_messages.AllGroupsListing;
  return proto.members_messages.AllGroupsListing.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.members_messages.AllGroupsListing} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.members_messages.AllGroupsListing}
 */
proto.members_messages.AllGroupsListing.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassGroupId(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVerified(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.members_messages.AllGroupsListing.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.members_messages.AllGroupsListing.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.members_messages.AllGroupsListing} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.AllGroupsListing.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getVerified();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.members_messages.AllGroupsListing.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.AllGroupsListing} returns this
 */
proto.members_messages.AllGroupsListing.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string pass_group_id = 2;
 * @return {string}
 */
proto.members_messages.AllGroupsListing.prototype.getPassGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.AllGroupsListing} returns this
 */
proto.members_messages.AllGroupsListing.prototype.setPassGroupId = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.members_messages.AllGroupsListing} returns this
 */
proto.members_messages.AllGroupsListing.prototype.clearPassGroupId = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.members_messages.AllGroupsListing.prototype.hasPassGroupId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bool verified = 3;
 * @return {boolean}
 */
proto.members_messages.AllGroupsListing.prototype.getVerified = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.members_messages.AllGroupsListing} returns this
 */
proto.members_messages.AllGroupsListing.prototype.setVerified = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.members_messages.GetAllGroupsListRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.members_messages.GetAllGroupsListRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.members_messages.GetAllGroupsListRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.GetAllGroupsListRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.members_messages.GetAllGroupsListRequest}
 */
proto.members_messages.GetAllGroupsListRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.members_messages.GetAllGroupsListRequest;
  return proto.members_messages.GetAllGroupsListRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.members_messages.GetAllGroupsListRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.members_messages.GetAllGroupsListRequest}
 */
proto.members_messages.GetAllGroupsListRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.members_messages.GetAllGroupsListRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.members_messages.GetAllGroupsListRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.members_messages.GetAllGroupsListRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.GetAllGroupsListRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.members_messages.GetAllGroupsListResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.members_messages.GetAllGroupsListResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.members_messages.GetAllGroupsListResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.members_messages.GetAllGroupsListResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.GetAllGroupsListResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
groupListingsList: jspb.Message.toObjectList(msg.getGroupListingsList(),
    proto.members_messages.AllGroupsListing.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.members_messages.GetAllGroupsListResponse}
 */
proto.members_messages.GetAllGroupsListResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.members_messages.GetAllGroupsListResponse;
  return proto.members_messages.GetAllGroupsListResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.members_messages.GetAllGroupsListResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.members_messages.GetAllGroupsListResponse}
 */
proto.members_messages.GetAllGroupsListResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.members_messages.AllGroupsListing;
      reader.readMessage(value,proto.members_messages.AllGroupsListing.deserializeBinaryFromReader);
      msg.addGroupListings(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.members_messages.GetAllGroupsListResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.members_messages.GetAllGroupsListResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.members_messages.GetAllGroupsListResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.GetAllGroupsListResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroupListingsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.members_messages.AllGroupsListing.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AllGroupsListing group_listings = 1;
 * @return {!Array<!proto.members_messages.AllGroupsListing>}
 */
proto.members_messages.GetAllGroupsListResponse.prototype.getGroupListingsList = function() {
  return /** @type{!Array<!proto.members_messages.AllGroupsListing>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.members_messages.AllGroupsListing, 1));
};


/**
 * @param {!Array<!proto.members_messages.AllGroupsListing>} value
 * @return {!proto.members_messages.GetAllGroupsListResponse} returns this
*/
proto.members_messages.GetAllGroupsListResponse.prototype.setGroupListingsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.members_messages.AllGroupsListing=} opt_value
 * @param {number=} opt_index
 * @return {!proto.members_messages.AllGroupsListing}
 */
proto.members_messages.GetAllGroupsListResponse.prototype.addGroupListings = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.members_messages.AllGroupsListing, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.members_messages.GetAllGroupsListResponse} returns this
 */
proto.members_messages.GetAllGroupsListResponse.prototype.clearGroupListingsList = function() {
  return this.setGroupListingsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.members_messages.VerifyAssignedPlanIdByMemberIdRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.members_messages.VerifyAssignedPlanIdByMemberIdRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.members_messages.VerifyAssignedPlanIdByMemberIdRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.VerifyAssignedPlanIdByMemberIdRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
memberId: jspb.Message.getFieldWithDefault(msg, 1, 0),
assignedPlanId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.members_messages.VerifyAssignedPlanIdByMemberIdRequest}
 */
proto.members_messages.VerifyAssignedPlanIdByMemberIdRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.members_messages.VerifyAssignedPlanIdByMemberIdRequest;
  return proto.members_messages.VerifyAssignedPlanIdByMemberIdRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.members_messages.VerifyAssignedPlanIdByMemberIdRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.members_messages.VerifyAssignedPlanIdByMemberIdRequest}
 */
proto.members_messages.VerifyAssignedPlanIdByMemberIdRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMemberId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssignedPlanId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.members_messages.VerifyAssignedPlanIdByMemberIdRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.members_messages.VerifyAssignedPlanIdByMemberIdRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.members_messages.VerifyAssignedPlanIdByMemberIdRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.VerifyAssignedPlanIdByMemberIdRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMemberId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getAssignedPlanId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 member_id = 1;
 * @return {number}
 */
proto.members_messages.VerifyAssignedPlanIdByMemberIdRequest.prototype.getMemberId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.members_messages.VerifyAssignedPlanIdByMemberIdRequest} returns this
 */
proto.members_messages.VerifyAssignedPlanIdByMemberIdRequest.prototype.setMemberId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string assigned_plan_id = 2;
 * @return {string}
 */
proto.members_messages.VerifyAssignedPlanIdByMemberIdRequest.prototype.getAssignedPlanId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.members_messages.VerifyAssignedPlanIdByMemberIdRequest} returns this
 */
proto.members_messages.VerifyAssignedPlanIdByMemberIdRequest.prototype.setAssignedPlanId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.members_messages.VerifyAssignedPlanIdByMemberIdResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.members_messages.VerifyAssignedPlanIdByMemberIdResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.members_messages.VerifyAssignedPlanIdByMemberIdResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.VerifyAssignedPlanIdByMemberIdResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
valid: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.members_messages.VerifyAssignedPlanIdByMemberIdResponse}
 */
proto.members_messages.VerifyAssignedPlanIdByMemberIdResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.members_messages.VerifyAssignedPlanIdByMemberIdResponse;
  return proto.members_messages.VerifyAssignedPlanIdByMemberIdResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.members_messages.VerifyAssignedPlanIdByMemberIdResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.members_messages.VerifyAssignedPlanIdByMemberIdResponse}
 */
proto.members_messages.VerifyAssignedPlanIdByMemberIdResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setValid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.members_messages.VerifyAssignedPlanIdByMemberIdResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.members_messages.VerifyAssignedPlanIdByMemberIdResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.members_messages.VerifyAssignedPlanIdByMemberIdResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.VerifyAssignedPlanIdByMemberIdResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValid();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool valid = 1;
 * @return {boolean}
 */
proto.members_messages.VerifyAssignedPlanIdByMemberIdResponse.prototype.getValid = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.members_messages.VerifyAssignedPlanIdByMemberIdResponse} returns this
 */
proto.members_messages.VerifyAssignedPlanIdByMemberIdResponse.prototype.setValid = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.members_messages.GetPolicyIdByMemberIdRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.members_messages.GetPolicyIdByMemberIdRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.members_messages.GetPolicyIdByMemberIdRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.GetPolicyIdByMemberIdRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
memberId: jspb.Message.getFieldWithDefault(msg, 1, 0),
dateOfInitialConsultation: jspb.Message.getFieldWithDefault(msg, 2, 0),
finalDateOfService: jspb.Message.getFieldWithDefault(msg, 3, 0),
caseId: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
coverageCheckDate: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.members_messages.GetPolicyIdByMemberIdRequest}
 */
proto.members_messages.GetPolicyIdByMemberIdRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.members_messages.GetPolicyIdByMemberIdRequest;
  return proto.members_messages.GetPolicyIdByMemberIdRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.members_messages.GetPolicyIdByMemberIdRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.members_messages.GetPolicyIdByMemberIdRequest}
 */
proto.members_messages.GetPolicyIdByMemberIdRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMemberId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDateOfInitialConsultation(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFinalDateOfService(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCaseId(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCoverageCheckDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.members_messages.GetPolicyIdByMemberIdRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.members_messages.GetPolicyIdByMemberIdRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.members_messages.GetPolicyIdByMemberIdRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.GetPolicyIdByMemberIdRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMemberId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getDateOfInitialConsultation();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getFinalDateOfService();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional int32 member_id = 1;
 * @return {number}
 */
proto.members_messages.GetPolicyIdByMemberIdRequest.prototype.getMemberId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.members_messages.GetPolicyIdByMemberIdRequest} returns this
 */
proto.members_messages.GetPolicyIdByMemberIdRequest.prototype.setMemberId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 date_of_initial_consultation = 2;
 * @return {number}
 */
proto.members_messages.GetPolicyIdByMemberIdRequest.prototype.getDateOfInitialConsultation = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.members_messages.GetPolicyIdByMemberIdRequest} returns this
 */
proto.members_messages.GetPolicyIdByMemberIdRequest.prototype.setDateOfInitialConsultation = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 final_date_of_service = 3;
 * @return {number}
 */
proto.members_messages.GetPolicyIdByMemberIdRequest.prototype.getFinalDateOfService = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.members_messages.GetPolicyIdByMemberIdRequest} returns this
 */
proto.members_messages.GetPolicyIdByMemberIdRequest.prototype.setFinalDateOfService = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 case_id = 4;
 * @return {number}
 */
proto.members_messages.GetPolicyIdByMemberIdRequest.prototype.getCaseId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.members_messages.GetPolicyIdByMemberIdRequest} returns this
 */
proto.members_messages.GetPolicyIdByMemberIdRequest.prototype.setCaseId = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.members_messages.GetPolicyIdByMemberIdRequest} returns this
 */
proto.members_messages.GetPolicyIdByMemberIdRequest.prototype.clearCaseId = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.members_messages.GetPolicyIdByMemberIdRequest.prototype.hasCaseId = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional int64 coverage_check_date = 5;
 * @return {number}
 */
proto.members_messages.GetPolicyIdByMemberIdRequest.prototype.getCoverageCheckDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.members_messages.GetPolicyIdByMemberIdRequest} returns this
 */
proto.members_messages.GetPolicyIdByMemberIdRequest.prototype.setCoverageCheckDate = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.members_messages.GetPolicyIdByMemberIdRequest} returns this
 */
proto.members_messages.GetPolicyIdByMemberIdRequest.prototype.clearCoverageCheckDate = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.members_messages.GetPolicyIdByMemberIdRequest.prototype.hasCoverageCheckDate = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.members_messages.GetPolicyIdByMemberIdResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.members_messages.GetPolicyIdByMemberIdResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.members_messages.GetPolicyIdByMemberIdResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.GetPolicyIdByMemberIdResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
lgPolicyId: jspb.Message.getFieldWithDefault(msg, 1, 0),
assignedPlanId: jspb.Message.getFieldWithDefault(msg, 2, 0),
effectiveDate: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.members_messages.GetPolicyIdByMemberIdResponse}
 */
proto.members_messages.GetPolicyIdByMemberIdResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.members_messages.GetPolicyIdByMemberIdResponse;
  return proto.members_messages.GetPolicyIdByMemberIdResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.members_messages.GetPolicyIdByMemberIdResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.members_messages.GetPolicyIdByMemberIdResponse}
 */
proto.members_messages.GetPolicyIdByMemberIdResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLgPolicyId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAssignedPlanId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEffectiveDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.members_messages.GetPolicyIdByMemberIdResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.members_messages.GetPolicyIdByMemberIdResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.members_messages.GetPolicyIdByMemberIdResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.GetPolicyIdByMemberIdResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLgPolicyId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getAssignedPlanId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getEffectiveDate();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional int32 lg_policy_id = 1;
 * @return {number}
 */
proto.members_messages.GetPolicyIdByMemberIdResponse.prototype.getLgPolicyId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.members_messages.GetPolicyIdByMemberIdResponse} returns this
 */
proto.members_messages.GetPolicyIdByMemberIdResponse.prototype.setLgPolicyId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 assigned_plan_id = 2;
 * @return {number}
 */
proto.members_messages.GetPolicyIdByMemberIdResponse.prototype.getAssignedPlanId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.members_messages.GetPolicyIdByMemberIdResponse} returns this
 */
proto.members_messages.GetPolicyIdByMemberIdResponse.prototype.setAssignedPlanId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 effective_date = 3;
 * @return {number}
 */
proto.members_messages.GetPolicyIdByMemberIdResponse.prototype.getEffectiveDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.members_messages.GetPolicyIdByMemberIdResponse} returns this
 */
proto.members_messages.GetPolicyIdByMemberIdResponse.prototype.setEffectiveDate = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.members_messages.HasPolicyByMemberIdRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.members_messages.HasPolicyByMemberIdRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.members_messages.HasPolicyByMemberIdRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.HasPolicyByMemberIdRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
memberId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.members_messages.HasPolicyByMemberIdRequest}
 */
proto.members_messages.HasPolicyByMemberIdRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.members_messages.HasPolicyByMemberIdRequest;
  return proto.members_messages.HasPolicyByMemberIdRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.members_messages.HasPolicyByMemberIdRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.members_messages.HasPolicyByMemberIdRequest}
 */
proto.members_messages.HasPolicyByMemberIdRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMemberId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.members_messages.HasPolicyByMemberIdRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.members_messages.HasPolicyByMemberIdRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.members_messages.HasPolicyByMemberIdRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.HasPolicyByMemberIdRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMemberId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 member_id = 1;
 * @return {number}
 */
proto.members_messages.HasPolicyByMemberIdRequest.prototype.getMemberId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.members_messages.HasPolicyByMemberIdRequest} returns this
 */
proto.members_messages.HasPolicyByMemberIdRequest.prototype.setMemberId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.members_messages.HasPolicyByMemberIdResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.members_messages.HasPolicyByMemberIdResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.members_messages.HasPolicyByMemberIdResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.HasPolicyByMemberIdResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
hasPolicy: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.members_messages.HasPolicyByMemberIdResponse}
 */
proto.members_messages.HasPolicyByMemberIdResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.members_messages.HasPolicyByMemberIdResponse;
  return proto.members_messages.HasPolicyByMemberIdResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.members_messages.HasPolicyByMemberIdResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.members_messages.HasPolicyByMemberIdResponse}
 */
proto.members_messages.HasPolicyByMemberIdResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasPolicy(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.members_messages.HasPolicyByMemberIdResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.members_messages.HasPolicyByMemberIdResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.members_messages.HasPolicyByMemberIdResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.HasPolicyByMemberIdResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHasPolicy();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool has_policy = 1;
 * @return {boolean}
 */
proto.members_messages.HasPolicyByMemberIdResponse.prototype.getHasPolicy = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.members_messages.HasPolicyByMemberIdResponse} returns this
 */
proto.members_messages.HasPolicyByMemberIdResponse.prototype.setHasPolicy = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.members_messages.GetCorePolicyIdByMemberIdRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.members_messages.GetCorePolicyIdByMemberIdRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.members_messages.GetCorePolicyIdByMemberIdRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.GetCorePolicyIdByMemberIdRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
memberId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.members_messages.GetCorePolicyIdByMemberIdRequest}
 */
proto.members_messages.GetCorePolicyIdByMemberIdRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.members_messages.GetCorePolicyIdByMemberIdRequest;
  return proto.members_messages.GetCorePolicyIdByMemberIdRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.members_messages.GetCorePolicyIdByMemberIdRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.members_messages.GetCorePolicyIdByMemberIdRequest}
 */
proto.members_messages.GetCorePolicyIdByMemberIdRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMemberId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.members_messages.GetCorePolicyIdByMemberIdRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.members_messages.GetCorePolicyIdByMemberIdRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.members_messages.GetCorePolicyIdByMemberIdRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.GetCorePolicyIdByMemberIdRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMemberId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 member_id = 1;
 * @return {number}
 */
proto.members_messages.GetCorePolicyIdByMemberIdRequest.prototype.getMemberId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.members_messages.GetCorePolicyIdByMemberIdRequest} returns this
 */
proto.members_messages.GetCorePolicyIdByMemberIdRequest.prototype.setMemberId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.members_messages.GetCorePolicyIdByMemberIdResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.members_messages.GetCorePolicyIdByMemberIdResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.members_messages.GetCorePolicyIdByMemberIdResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.members_messages.GetCorePolicyIdByMemberIdResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.GetCorePolicyIdByMemberIdResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
memberLgPolicyIdsList: jspb.Message.toObjectList(msg.getMemberLgPolicyIdsList(),
    proto.members_messages.MemberLgPolicyId.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.members_messages.GetCorePolicyIdByMemberIdResponse}
 */
proto.members_messages.GetCorePolicyIdByMemberIdResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.members_messages.GetCorePolicyIdByMemberIdResponse;
  return proto.members_messages.GetCorePolicyIdByMemberIdResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.members_messages.GetCorePolicyIdByMemberIdResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.members_messages.GetCorePolicyIdByMemberIdResponse}
 */
proto.members_messages.GetCorePolicyIdByMemberIdResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.members_messages.MemberLgPolicyId;
      reader.readMessage(value,proto.members_messages.MemberLgPolicyId.deserializeBinaryFromReader);
      msg.addMemberLgPolicyIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.members_messages.GetCorePolicyIdByMemberIdResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.members_messages.GetCorePolicyIdByMemberIdResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.members_messages.GetCorePolicyIdByMemberIdResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.GetCorePolicyIdByMemberIdResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMemberLgPolicyIdsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.members_messages.MemberLgPolicyId.serializeBinaryToWriter
    );
  }
};


/**
 * repeated MemberLgPolicyId member_lg_policy_ids = 1;
 * @return {!Array<!proto.members_messages.MemberLgPolicyId>}
 */
proto.members_messages.GetCorePolicyIdByMemberIdResponse.prototype.getMemberLgPolicyIdsList = function() {
  return /** @type{!Array<!proto.members_messages.MemberLgPolicyId>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.members_messages.MemberLgPolicyId, 1));
};


/**
 * @param {!Array<!proto.members_messages.MemberLgPolicyId>} value
 * @return {!proto.members_messages.GetCorePolicyIdByMemberIdResponse} returns this
*/
proto.members_messages.GetCorePolicyIdByMemberIdResponse.prototype.setMemberLgPolicyIdsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.members_messages.MemberLgPolicyId=} opt_value
 * @param {number=} opt_index
 * @return {!proto.members_messages.MemberLgPolicyId}
 */
proto.members_messages.GetCorePolicyIdByMemberIdResponse.prototype.addMemberLgPolicyIds = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.members_messages.MemberLgPolicyId, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.members_messages.GetCorePolicyIdByMemberIdResponse} returns this
 */
proto.members_messages.GetCorePolicyIdByMemberIdResponse.prototype.clearMemberLgPolicyIdsList = function() {
  return this.setMemberLgPolicyIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.members_messages.GetCoreMemberAssignedPlansRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.members_messages.GetCoreMemberAssignedPlansRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.members_messages.GetCoreMemberAssignedPlansRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.GetCoreMemberAssignedPlansRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
memberId: jspb.Message.getFieldWithDefault(msg, 1, 0),
initialConsultationDate: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.members_messages.GetCoreMemberAssignedPlansRequest}
 */
proto.members_messages.GetCoreMemberAssignedPlansRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.members_messages.GetCoreMemberAssignedPlansRequest;
  return proto.members_messages.GetCoreMemberAssignedPlansRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.members_messages.GetCoreMemberAssignedPlansRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.members_messages.GetCoreMemberAssignedPlansRequest}
 */
proto.members_messages.GetCoreMemberAssignedPlansRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMemberId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setInitialConsultationDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.members_messages.GetCoreMemberAssignedPlansRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.members_messages.GetCoreMemberAssignedPlansRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.members_messages.GetCoreMemberAssignedPlansRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.GetCoreMemberAssignedPlansRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMemberId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getInitialConsultationDate();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional int32 member_id = 1;
 * @return {number}
 */
proto.members_messages.GetCoreMemberAssignedPlansRequest.prototype.getMemberId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.members_messages.GetCoreMemberAssignedPlansRequest} returns this
 */
proto.members_messages.GetCoreMemberAssignedPlansRequest.prototype.setMemberId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 initial_consultation_date = 2;
 * @return {number}
 */
proto.members_messages.GetCoreMemberAssignedPlansRequest.prototype.getInitialConsultationDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.members_messages.GetCoreMemberAssignedPlansRequest} returns this
 */
proto.members_messages.GetCoreMemberAssignedPlansRequest.prototype.setInitialConsultationDate = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.members_messages.GetCoreMemberAssignedPlansResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.members_messages.GetCoreMemberAssignedPlansResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.members_messages.GetCoreMemberAssignedPlansResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.members_messages.GetCoreMemberAssignedPlansResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.GetCoreMemberAssignedPlansResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
assignedPlansList: jspb.Message.toObjectList(msg.getAssignedPlansList(),
    proto.members_messages.MemberAssignedPlans.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.members_messages.GetCoreMemberAssignedPlansResponse}
 */
proto.members_messages.GetCoreMemberAssignedPlansResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.members_messages.GetCoreMemberAssignedPlansResponse;
  return proto.members_messages.GetCoreMemberAssignedPlansResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.members_messages.GetCoreMemberAssignedPlansResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.members_messages.GetCoreMemberAssignedPlansResponse}
 */
proto.members_messages.GetCoreMemberAssignedPlansResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.members_messages.MemberAssignedPlans;
      reader.readMessage(value,proto.members_messages.MemberAssignedPlans.deserializeBinaryFromReader);
      msg.addAssignedPlans(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.members_messages.GetCoreMemberAssignedPlansResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.members_messages.GetCoreMemberAssignedPlansResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.members_messages.GetCoreMemberAssignedPlansResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.GetCoreMemberAssignedPlansResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAssignedPlansList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.members_messages.MemberAssignedPlans.serializeBinaryToWriter
    );
  }
};


/**
 * repeated MemberAssignedPlans assigned_plans = 1;
 * @return {!Array<!proto.members_messages.MemberAssignedPlans>}
 */
proto.members_messages.GetCoreMemberAssignedPlansResponse.prototype.getAssignedPlansList = function() {
  return /** @type{!Array<!proto.members_messages.MemberAssignedPlans>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.members_messages.MemberAssignedPlans, 1));
};


/**
 * @param {!Array<!proto.members_messages.MemberAssignedPlans>} value
 * @return {!proto.members_messages.GetCoreMemberAssignedPlansResponse} returns this
*/
proto.members_messages.GetCoreMemberAssignedPlansResponse.prototype.setAssignedPlansList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.members_messages.MemberAssignedPlans=} opt_value
 * @param {number=} opt_index
 * @return {!proto.members_messages.MemberAssignedPlans}
 */
proto.members_messages.GetCoreMemberAssignedPlansResponse.prototype.addAssignedPlans = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.members_messages.MemberAssignedPlans, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.members_messages.GetCoreMemberAssignedPlansResponse} returns this
 */
proto.members_messages.GetCoreMemberAssignedPlansResponse.prototype.clearAssignedPlansList = function() {
  return this.setAssignedPlansList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.members_messages.IsPremiumPaidRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.members_messages.IsPremiumPaidRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.members_messages.IsPremiumPaidRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.IsPremiumPaidRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
claimId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.members_messages.IsPremiumPaidRequest}
 */
proto.members_messages.IsPremiumPaidRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.members_messages.IsPremiumPaidRequest;
  return proto.members_messages.IsPremiumPaidRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.members_messages.IsPremiumPaidRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.members_messages.IsPremiumPaidRequest}
 */
proto.members_messages.IsPremiumPaidRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClaimId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.members_messages.IsPremiumPaidRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.members_messages.IsPremiumPaidRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.members_messages.IsPremiumPaidRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.IsPremiumPaidRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 claim_id = 1;
 * @return {number}
 */
proto.members_messages.IsPremiumPaidRequest.prototype.getClaimId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.members_messages.IsPremiumPaidRequest} returns this
 */
proto.members_messages.IsPremiumPaidRequest.prototype.setClaimId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.members_messages.IsPremiumPaidResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.members_messages.IsPremiumPaidResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.members_messages.IsPremiumPaidResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.IsPremiumPaidResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
isPremiumPaid: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.members_messages.IsPremiumPaidResponse}
 */
proto.members_messages.IsPremiumPaidResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.members_messages.IsPremiumPaidResponse;
  return proto.members_messages.IsPremiumPaidResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.members_messages.IsPremiumPaidResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.members_messages.IsPremiumPaidResponse}
 */
proto.members_messages.IsPremiumPaidResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsPremiumPaid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.members_messages.IsPremiumPaidResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.members_messages.IsPremiumPaidResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.members_messages.IsPremiumPaidResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.members_messages.IsPremiumPaidResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIsPremiumPaid();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool is_premium_paid = 1;
 * @return {boolean}
 */
proto.members_messages.IsPremiumPaidResponse.prototype.getIsPremiumPaid = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.members_messages.IsPremiumPaidResponse} returns this
 */
proto.members_messages.IsPremiumPaidResponse.prototype.setIsPremiumPaid = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * @enum {number}
 */
proto.members_messages.PreferenceTypes = {
  DIGITAL_FULFILLMENT: 0
};

/**
 * @enum {number}
 */
proto.members_messages.Underwriter = {
  ASSURANT: 0,
  NATIONWIDE: 1,
  VSC: 2,
  LASG: 3
};

goog.object.extend(exports, proto.members_messages);
